import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=8d892d7c"
import script from "./rich-editor.vue?vue&type=script&lang=ts"
export * from "./rich-editor.vue?vue&type=script&lang=ts"
import style0 from "./rich-editor.vue?vue&type=style&index=0&id=8d892d7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports